// extracted by mini-css-extract-plugin
module.exports = {"invitationModalSent":"InvitationFormSent_invitationModalSent__VZCzs","buttons":"InvitationFormSent_buttons__RUArT","info":"InvitationFormSent_info__2Qoay"};